import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "PageLayout__Backdrop absolute inset-0 bg-true-black/60" }, null, -1);
const _hoisted_2 = { class: "PageLayout__UI absolute inset-0 flex flex-col lg:p-24 lg:pb-20 pointer-events-none" };
const _hoisted_3 = { class: "flex justify-end items-center gap-6 h-56 lg:h-40 mb-auto py-16 lg:py-0 px-20 lg:px-0 *:pointer-events-auto" };
import { ref, shallowRef, onMounted, onBeforeMount } from "vue";
import { onKeyDown } from "@vueuse/core";
import Lenis from "lenis";
import { useAppState } from "@/services/Composition";
import useGSAP from "@/composables/useGSAP";
import Viewport from "@/store/modules/Viewport";
import LayoutTheme, { setLayoutTheme } from "@/store/modules/LayoutTheme";
import { setFPS } from "@/utils/frameToTime";
import { smoothOriginChange } from "@/utils/gsap.helpers";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PageLayout',
    props: {
        theme: { default: "light" }
    },
    emits: ["enterContent"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const gsap = useGSAP();
        const frames = setFPS(60);
        const { send } = useAppState();
        const wrapper = ref(null);
        const content = ref(null);
        const close = () => send("BACK");
        function onBeforeEnter(el) {
            const $ = gsap.utils.selector(el);
            gsap.set($(".PageLayout__Content"), { autoAlpha: 0 });
        }
        function onEnter(el, onComplete) {
            const $ = gsap.utils.selector(el);
            const tl = gsap.timeline({
                onComplete,
                defaults: {
                    ease: "ease.out"
                }
            })
                .from($(".PageLayout__Backdrop"), {
                opacity: 0,
                duration: frames(40)
            }, 0)
                .add("content", frames(40))
                .set($(".PageLayout__Content"), { clearProps: "opacity,visibility" }, "content")
                .call(setLayoutTheme, [props.theme], "content")
                .call(emit, ["enterContent", el], "content")
                .from($(".PageLayout__UI"), {
                autoAlpha: 0,
                duration: frames(30)
            }, "content");
            // Background
            tl.add((() => {
                const [background] = $(".PageLayout__Background");
                gsap.set(background, { x: 0.75 * Viewport.windowWidth, y: Viewport.windowHeight, rotation: -40, transformOrigin: "25% 0%" });
                smoothOriginChange(background, "50% 50%");
                return gsap.to(background, {
                    x: 0,
                    y: 0,
                    rotation: 0,
                    duration: frames(40),
                    ease: "ease.out"
                });
            })(), 0);
        }
        const lenis = shallowRef(null);
        const updateScroll = (time) => {
            var _a;
            (_a = lenis.value) === null || _a === void 0 ? void 0 : _a.raf(time * 1000);
        };
        onMounted(() => {
            if (!(wrapper.value && content.value))
                return;
            lenis.value = new Lenis({
                wrapper: wrapper.value,
                content: content.value,
                eventsTarget: window
            });
            gsap.ticker.add(updateScroll);
        });
        onKeyDown(["Escape"], close);
        onBeforeMount(() => {
            var _a;
            gsap.ticker.remove(updateScroll);
            (_a = lenis.value) === null || _a === void 0 ? void 0 : _a.destroy();
        });
        __expose({ wrapper, lenis });
        return (_ctx, _cache) => {
            const _component_UIDogEared = _resolveComponent("UIDogEared");
            const _component_UIBtnClose = _resolveComponent("UIBtnClose");
            return (_openBlock(), _createBlock(_Transition, {
                appear: "",
                onBeforeEnter: onBeforeEnter,
                onEnter: onEnter
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(["PageLayout absolute inset-0 overflow-hidden", { 'text-black': _ctx.theme === 'light' }])
                    }, [
                        _hoisted_1,
                        _createVNode(_component_UIDogEared, {
                            class: "PageLayout__Background !absolute inset-0",
                            width: _unref(Viewport).isDesktop ? '27%' : '45%',
                            height: "68%",
                            delay: _unref(frames)(10),
                            theme: _ctx.theme
                        }, null, 8, ["width", "delay", "theme"]),
                        _createElementVNode("div", {
                            ref_key: "wrapper",
                            ref: wrapper,
                            class: "PageLayout__Wrapper absolute inset-0 isolate overflow-x-hidden overflow-y-auto overscroll-contain"
                        }, [
                            _createElementVNode("div", {
                                ref_key: "content",
                                ref: content,
                                class: "PageLayout__Content flex min-h-full *:w-full"
                            }, [
                                _renderSlot(_ctx.$slots, "default")
                            ], 512)
                        ], 512),
                        _createElementVNode("div", _hoisted_2, [
                            _renderSlot(_ctx.$slots, "ui"),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_UIBtnClose, {
                                    theme: _unref(LayoutTheme).header,
                                    onClick: close
                                }, null, 8, ["theme"])
                            ])
                        ])
                    ], 2)
                ]),
                _: 3
            }));
        };
    }
});
